import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Activity } from './features/activity/Activity';

import { DynamicStyleLoader, PageNotFound } from './MBRoutes';
import MentalMath from "./features/mentalMath/MentalMath";
import { useEffect, useState } from "react";
import { AppContext } from './context/context';
import SmartSheet from './features/smartSheet/SmartSheet';
import { AdaptivePractice } from "./features/adaptivePractice/AdaptivePractice";
import { QuestionPreview } from "./features/adaptivePractice/QuestionPreview";
import { PracticeQuestion } from "./features/adaptivePractice/PracticeQuestion";
import { Hots } from "./features/adaptivePractice/hots/Hots";
import { AdaptiveQuizBuilder } from "./features/adaptiveQuiz/builder/AdaptiveQuizBuilder";
import { AdaptiveQuizPlayer } from "./features/adaptiveQuiz/player/AdaptiveQuizPlayer";
import DailyChallengeForStudents from "./features/adaptivePractice/DailyChallengeForStudents";
import Feedback from "./features/activity/Feedback";
import ClassworkQuestions from "./features/classwork/ClassworkQuestions";
import { RiseSession } from "./features/adaptivePractice/riseSession/RiseSession";

function App() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const [windowHeight, setWindowHeight] = useState(window.innerHeight)
  const IFRAME_ACTIVITY = ['mousemove', 'keydown', 'click', 'touchstart'];
  const setWindowDimensions = () => {
    console.log("resize")
    setWindowWidth(window.innerWidth)
    setWindowHeight(window.innerHeight)
  }
  useEffect(() => {
    window.addEventListener('resize', setWindowDimensions);

    // Notify parent window of user activity within the iframe
    IFRAME_ACTIVITY.forEach(event =>
      window.addEventListener(event, () => { messageForParent('IFRAME_ACTIVITY'); })
    );

    return () => {
      window.removeEventListener('resize', setWindowDimensions);

      // Remove event listeners when the component unmounts
      IFRAME_ACTIVITY.forEach(event =>
        window.removeEventListener(event, () => { messageForParent('IFRAME_ACTIVITY'); })
      );
    }
  }, [])

  const messageForParent = (type: string, data: any = {}) => {
    const payload = JSON.stringify({ type, data });

    // Browser iframe host
    if (window.parent && window.parent !== window) {
      window.parent.postMessage(payload, '*');
    }

    // React Native WebView host
    const rnWebView = (window as any).ReactNativeWebView;
    if (rnWebView?.postMessage) {
      rnWebView.postMessage(payload);
    }
  }

  const navigateTo = (path: string) => {
    window.location.replace(path);
  }

  return (<AppContext.Provider value={{ windowHeight, windowWidth, messageForParent: messageForParent, navigateTo: navigateTo }}>
    <Router>
      <DynamicStyleLoader></DynamicStyleLoader>
      <Routes>
        <Route path='/learnActivity' element={<Activity></Activity>}></Route>
        <Route path='/mentalMath' element={<MentalMath></MentalMath>}></Route>
        <Route path='/adaptivePractice' element={<AdaptivePractice></AdaptivePractice>}></Route>
        <Route path='/previewQuestion' element={<QuestionPreview></QuestionPreview>}></Route>
        <Route path='/practiceQuestion' element={<PracticeQuestion></PracticeQuestion>}></Route>
        <Route path='/hots' element={<Hots></Hots>}></Route>
        <Route path='/adaptiveQuizBuilder' element={<AdaptiveQuizBuilder></AdaptiveQuizBuilder>}></Route>
        <Route path='/adaptiveQuiz' element={<AdaptiveQuizPlayer></AdaptiveQuizPlayer>}></Route>
        <Route path='/smartSheet' element={<SmartSheet></SmartSheet>}></Route>
        <Route path='/dailyChallenge' element={<DailyChallengeForStudents></DailyChallengeForStudents>}></Route>
        <Route path='/adaptiveRiseSession' element={<RiseSession></RiseSession>}></Route>
        <Route path='*' element={<PageNotFound></PageNotFound>}></Route>
        <Route path=":type/:id/feedback" element={<Feedback />}></Route>
        <Route path='/classwork' element={<ClassworkQuestions />}></Route>
      </Routes>
    </Router>
  </AppContext.Provider>);
}

export default App;
